import React from 'react';
import * as R from 'ramda';

import { PaginationContainer } from 'src/shared/table/PaginationContainer';
import { useCovenantTrackingPortfolio, useRouterQuery } from 'src/hooks';
import { getEndOfMonth, subtractDate, getNowDate } from 'src/utils';
import { Layout, HeaderContainer, ToolbarContainer, Table } from './';

export const Main: React.FC = () => {
  const query = useRouterQuery();
  const selectedMonth = query?.month ?? null;
  const endOfPreviousMonth = getEndOfMonth(subtractDate(getNowDate()) as string);
  const selectedDate = selectedMonth ?? endOfPreviousMonth;

  const { hasData, loading, rows, paginatedRows, columns, count } = useCovenantTrackingPortfolio(
    selectedDate,
    endOfPreviousMonth,
  );

  const tableExportData = React.useMemo(
    () => ({
      rows,
      columns,
    }),
    [rows, columns],
  );

  const isFirstLoading = !hasData && loading;
  const hasCompanies = !isFirstLoading && !R.isEmpty(rows);

  return (
    <Layout
      loading={loading}
      isFirstLoading={isFirstLoading}
      hasCompanies={hasCompanies}
      renderHeader={<HeaderContainer tableExportData={tableExportData} />}
      renderToolbar={
        <ToolbarContainer
          loading={loading}
          maxMonth={endOfPreviousMonth}
          initialSelectedDate={selectedDate}
        />
      }
      renderTable={<Table rows={paginatedRows} columns={columns} />}
      renderPagination={<PaginationContainer count={count} />}
    />
  );
};
